import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
 
import { TourneeModel } from '../models/tournee.model';
import { DataService } from '../services/data/data.service';
import { HomeService } from '../services/home-service/home.service';
import { SaleService } from '../services/sale/sale.service';
 
@Injectable({
  providedIn: 'root',
})

export class TourneeResolverService implements Resolve<TourneeModel> {


  constructor(private dataService: DataService, private homeService:HomeService, private saleService: SaleService) {
  }
 
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TourneeModel> | Observable<never> {
    let id = route.paramMap.get('tourneeId');
    let marketId = route.paramMap.get('marketId');
    // let countryCode = route.paramMap.get('countryCode');
    // let postalCode = route.paramMap.get('postalCode');
    // let status = route.paramMap.get('status');
    if(!!marketId){
      return this.dataService.getMarketTournee(marketId,id).pipe(
        take(1),
        mergeMap(item => {
          if (item && Object.keys(item).length>1) {
            item.market = {key:marketId};
            return of(item);
          } else { // id not found
            console.log('go to home', item);
            this.homeService.navigateToHome('unknown.sale')
          }
        })
      ); 
    }
    else{
      return this.dataService.getTournee(id).pipe(
          take(1),
          mergeMap(item => {
            if (item && Object.keys(item).length>1) {
              item.details.datesPlaces = this.saleService.getDatesPlaces(item.details);
              this.saleService.enrichPrices(item);
              return of(item);
            } else { // id not found
              console.log('go to home', item);
              this.homeService.navigateToHome('unknown.sale')
            }
          })
        );
      }      
    }

}